/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ZandaHealth API
 * OpenAPI spec version: 1.0
 */

export type DiscountType = (typeof DiscountType)[keyof typeof DiscountType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DiscountType = {
  Percentage: 0,
  Currency: 1,
} as const;
